import React from "react";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { clientPath } from "../../config/key";
import { handleCopyToClipboard } from "../../utils/function";
import { getVideoMeetingResponse } from "../../utils/videoPlatform";

const RealtimeKitMeetLink = (props) => {
  const { updateData } = props;
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const videoMeetingResponse = getVideoMeetingResponse(updateData);

  const doctorLink = `${clientPath}/realtimekit-video-call/${updateData?._id}`;
  const clientLink = `${clientPath}/realtimekit-video-call/${updateData?._id}`;
  const guestLink = `${clientPath}/join/${updateData?._id}`;

  return (
    <Form.Group className="mb-3">
      <h5 className="meeting-link-text">
        {role === "admin" ? t("Video meeting Links") : t("Guest join link")}
      </h5>
      <div className="meeting-link-grid">
        {videoMeetingResponse?.doctorParticipant && role === "admin" && (
          <div>
            <a href={doctorLink}>{t("Doctor")} </a>{" "}
            <Button
              onClick={() => {
                handleCopyToClipboard(doctorLink, "doctor", t);
              }}
              className="copy-btn"
            >
              {t("Copy")} <i className="las la-copy"></i>
            </Button>
          </div>
        )}
        {videoMeetingResponse?.clientParticipant && role === "admin" && (
          <>
            |&nbsp;
            <div>
              <a href={clientLink}> {t("Client")} </a>{" "}
              <Button
                onClick={() => {
                  handleCopyToClipboard(clientLink, "client", t);
                }}
                className="copy-btn"
              >
                {t("Copy")} <i className="las la-copy"></i>
              </Button>{" "}
            </div>
          </>
        )}
        {videoMeetingResponse?.additionalParticipant && (
          <>
            {role === "admin" && <span>|&nbsp;</span>}
            <div>
              {role === "admin" && <a href={guestLink}>{t("Guest")}</a>}
              <Button
                onClick={() => handleCopyToClipboard(guestLink, "guest", t)}
                className="copy-btn"
              >
                {t("Copy")} <i className="las la-copy"></i>
              </Button>
            </div>
          </>
        )}
      </div>
    </Form.Group>
  );
};

export default RealtimeKitMeetLink;
